const aaa = [
	{
		path: "fictitious",
		component: () => import("@/views/chanpin/fictitious/fictitious.vue"),
		meta:{title:'虚拟',keepAlive:false},
	},
	{
		path: "addfictitiouscard",
		component: () => import("@/views/chanpin/fictitious/addfictitiouscard.vue"),
		meta:{title:'编辑虚拟卡'},
	},
	{
		path: "addfictitiousgoods",
		component: () => import("@/views/chanpin/fictitious/addfictitiousgoods.vue"),
		meta:{title:'编辑虚拟商品'},
	},
	{
		path: "cardDetail",
		component: () => import("@/views/chanpin/fictitious/cardDetail.vue"),
		meta:{title:'编辑虚拟商品'},
	},{
		path: "usecoupon",
		component: () => import("@/views/chanpin/fictitious/usecoupon.vue"),
		meta:{title:'领取记录'},
	},
]
export default aaa;